import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Box, CircularProgress, Typography } from "@material-ui/core";
import { startPublicQuotation } from "../../services/publicQuotationApi";
import { ace } from "./theme";

/** Creates a draft server-side and sends the customer to the tokenized wizard. */
const PublicCftEntry = () => {
  const history = useHistory();
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await startPublicQuotation();
        const token = res.data?.token;
        if (!token) throw new Error("No token");
        if (!cancelled) history.replace(`/public/cft/${token}`);
      } catch (e) {
        if (!cancelled) setError(e?.response?.data?.message || "Could not start a new request. Try again later.");
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [history]);

  if (error) {
    return (
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        minHeight="100vh"
        style={{ background: ace.grayBg, padding: 24 }}
      >
        <Typography style={{ color: ace.charcoal }}>{error}</Typography>
      </Box>
    );
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      style={{ background: ace.grayBg }}
    >
      <CircularProgress style={{ color: ace.red }} />
      <Typography variant="body2" style={{ color: ace.muted, marginTop: 16 }}>
        Starting your quote…
      </Typography>
    </Box>
  );
};

export default PublicCftEntry;
